<!--
지역설정 1개 속성 편집 컴포넌트 (generic) — TASK-125 (2026-08-15)

기존 addr-sample.vue / center-notice.vue 는 설정명(config name)만 다른 사실상 복제였다.
신규 항목마다 복제본을 늘리지 않도록 설정명/제목을 props 로 받는 공용 컴포넌트로 작성한다.
서버는 generic 라우트 configs/{name} (Regions\Configs\ShowAttr / UpdateAttr) 를 그대로 재사용한다.

기존 2개 컴포넌트는 무변경 존치 (회귀 위험 0). 신규 항목만 본 컴포넌트를 사용한다.

사용 예)
    <app-region-config-attr-editor
        ref="addr-guide"
        config-name="addr_guide"
        title="주소 기입 안내 작성"
        csrf-token="..."
    ></app-region-config-attr-editor>

    app.$refs['addr-guide'].form(region_id)
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-3-4">

            <div class="uk-modal-header">
                <h4>{{ title }}</h4>
            </div>

            <div class="uk-modal-body uk-padding-small">
                <!-- 에디터 -->
                <app-jodit
                    ref="jodit"
                    :init-value="content"
                    :options="{readonly: true}"
                ></app-jodit>
            </div>


            <div class="uk-modal-footer uk-text-right">
                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>

                <button
                    type="button"
                    class="uk-button uk-button-primary"
                    v-on:click="submit()"
                >
                    <span uk-icon="icon: check"></span>
                    저장
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            /**
             * csrf token
             */
            csrfToken: {
                type: String,
                required: true,
            },

            /**
             * (string) 지역설정 항목명 (App\Config\RegionConfig 에 정의된 name)
             *  - 조회/저장 URL 과 응답/요청 키로 그대로 사용됨
             */
            configName: {
                type: String,
                required: true,
            },

            /**
             * (string) 모달 제목
             */
            title: {
                type: String,
                default: '설정 작성',
            },
        },
        data: function () {
            return {

                /**
                 * (integer)
                 */
                regionId: null,

                /**
                 * (string) 글내용
                 */
                content: null,


            };
        },
        computed: {

        },
        methods: {
            /**
             * 설정 조회/저장 URL
             * @returns string
             */
            url() {
                return '/regions/' + this.regionId + '/configs/' + this.configName;
            },

            /**
             * 입력폼 display
             */
            show() {
                UIkit.modal(this.$el).show();

                // 에디터 옵션변경
                let editor = this.$refs.jodit.getJodit();
                editor.setReadOnly(false);

                // 내용 초기화
                this.$refs.jodit.setEditorValue(this.content);
            },

            /**
             * 폼
             * @param region_id 지역ID
             */
            form(region_id) {
                this.regionId = region_id;

                // promise 생성
                let load = new Promise((resolve, reject) => {

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: this.url(),
                        contentType: 'application/json',
                        data: {},
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                load.then((response) => {
                    // 응답 키 = 설정항목명 (Regions\Configs\ShowAttr)
                    let value = response[this.configName];
                    this.content = (value === undefined) ? null : value;

                    // 폼띄우기
                    this.show();
                });
            },

            /**
             * submit
             */
            submit() {

                // 요청 키 = 설정항목명 (Regions\Configs\UpdateAttr)
                let data = {
                    '_token': this.csrfToken,
                };
                data[this.configName] = this.$refs.jodit.getEditorValue();

                // ajax 옵션
                let opts = {
                    type: 'patch',
                    url: this.url(),
                    data: data,
                    success: (response, textStatus, jqXHR) => {
                        UIkit.modal.alert(response.msg).then(function () {
                            $.app.refresh();
                        });
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>
